export default "__VITE_ASSET__By$P8rRi__"